import { render, staticRenderFns } from "./HallBackGround.vue?vue&type=template&id=53277104&lang=pug"
import script from "./HallBackGround.vue?vue&type=script&lang=js"
export * from "./HallBackGround.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports